import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
} from "reactstrap";
import moment from "moment";
import get from "lodash/get";
import { useEffect, useState } from "react";
import CustomDatepicker from "../CustomDatepicker";
import history from "../../history";
import CartTitle from "../../components/CartTitle";
import Loader from "../Loader";
import { Icon } from "react-icons-kit";
import { ic_file_upload } from "react-icons-kit/md/ic_file_upload";
import { close } from "react-icons-kit/fa/close";
import InputText from "../InputText";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomButton from "../CustomButton";
import MultiSelect from "../MultiSelect";

import "../../assets/scss/components/MeterialTable/index.scss";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import CKEditor from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { nameValidation, numberValidation } from "../../utils/helperFunction";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as sessionActions from "../../redux/moderation/tours/actions";
import * as globalActions from "../../redux/Global/actions";
import { validation } from "../../helpers/validation";
import PartnerPreviewPage from "../PartnerPreviewPage";
import TourPreviewPage from "../TourPreviewPage";

const _ = { get };

class AddNewTour extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      startPoint: "",
      startPointSourceLatitude: "",
      startPointSourceLongitude: "",
      endPoint: "",
      endPointSourceLatitude: "",
      endPointSourceLongitude: "",
      startDate: "",
      endDate: "",
      description: "",
      region: "",
      category: "TOUR",
      country: "",
      locality: null,
      distanceCovered: "",
      state: "",
      city: "",
      toggleUploadImageSection: false,
      thumbnailImage: "",
      images: [],
      files: [],
      thumbnailImagePlaceholder: "",
      imagePlaceHolder: [],
      errors: {},
      redirectionUrl: "",
      thumbnailPartnerImage: "",
      thumbnailPartnerImagePlaceholder: "",
      togglePreviewModal: false,
      partnerName: "",
      partnerEmailId: "",
      eventName: "",
      errorsImage: [],
      updatedDetails: {},
      isGalleryUpdated: false,
    };
  }

  handleGoBack = () => {
    this.props.handleToggleModel();
  };

  handleCreateTour = (data) => {
    this.props.actions.createTour(data, this.handleCallBack);
  };

  handleCallBack = () => {
    this.props.handleToggleModel();
    this.props.fetchList({
      page: 0,
      limit: 100,
      startDate: null,
      endDate: null,
      status: "PENDING",
      category: "TOUR",
    });
  };

  handleUpdateTourInfo = (data) => {
    this.props.actions.updateTourInfo(data, this.handleUpdateTourCallBack);
  };

  handleUpdateTourCallBack = () => {
    this.props.handleToggleModel();
    this.props.actions.fetchToursDetail(
      this.props.toursDetails && this.props.toursDetails._id
    );
  };

  handleChange = (e) => {
    let state = this.state;
    let value = e.target.value;
    state[e.target.name] = value;
    let errorMessage = validation(
      e.target.name,
      e.target.value,
      this.props.elements
    );
    if (errorMessage) {
      state.errors[e.target.name] = errorMessage;
    } else {
      delete state.errors[e.target.name];
    }
    if (this.props.formType == "update") {
      if (e.target.name === "distanceCovered") {
        state.updatedDetails = {
          ...state.updatedDetails,
          totalDistance: e.target.value,
          isGalleryUpdated: state.isGalleryUpdated === true ? true : false,
        };
      } else {
        state.updatedDetails = {
          ...state.updatedDetails,
          [e.target.name]: e.target.value,
          isGalleryUpdated: state.isGalleryUpdated === true ? true : false,
        };
      }
    }
    this.setState({ ...state });
  };

  handleChangeStartingLocation = (startPoint) => {
    this.setState({ startPoint });
    if (this.props.formType == "update") {
      this.setState({
        updatedDetails: {
          ...this.state.updatedDetails,
          source: startPoint,
          isGalleryUpdated: this.state.isGalleryUpdated === true ? true : false,
        },
      });
    }
  };

  handleSelectGeoAddressForStartPoint = (startPoint) => {
    this.setState({ startPoint: startPoint });
    geocodeByAddress(startPoint)
      .then((results) => getLatLng(results[0]))
      .then(({ lat, lng }) => {
        this.setState({
          startPointSourceLatitude: lat,
          startPointSourceLongitude: lng,
        });
      })
      .catch((error) => console.error("Error", error));
    if (this.props.formType == "update") {
      this.setState({
        updatedDetails: {
          ...this.state.updatedDetails,
          source: startPoint,
          sourceLatitude: this.state.startPointSourceLatitude,
          sourceLongitude: this.state.startPointSourceLongitude,
          isGalleryUpdated: this.state.isGalleryUpdated === true ? true : false,
        },
      });
    }
  };

  handleChangeEndingLocation = (endPoint) => {
    this.setState({ endPoint });
    // if (this.props.formType == "update") {
    //   this.setState({
    //     updatedDetails: {
    //       ...this.state.updatedDetails,
    //       destination: endPoint,
    //       isGalleryUpdated: this.state.isGalleryUpdated === true ? true : false,
    //     },
    //   });
    // }
  };

  handleSelectGeoAddressForEndPoint = (endPoint) => {
    this.setState({ endPoint: endPoint });
    geocodeByAddress(endPoint)
      .then((results) => getLatLng(results[0]))
      .then(({ lat, lng }) => {
        this.setState({
          endPointSourceLatitude: lat,
          endPointSourceLongitude: lng,
        });
      })
      .catch((error) => console.error("Error", error));
    if (this.props.formType == "update") {
      this.setState({
        updatedDetails: {
          ...this.state.updatedDetails,
          destination: endPoint,
          destinationLatitude: this.state.endPointSourceLatitude,
          destinationLongitude: this.state.endPointSourceLongitude,
          isGalleryUpdated: this.state.isGalleryUpdated === true ? true : false,
        },
      });
    }
  };

  handleTourDates = (date, id) => {
    let state = { ...this.state };
    if (id === "start") {
      state.startDate = date;
      state.endDate = "";
      this.setState(state);
      if (this.props.formType == "update") {
        this.setState({
          updatedDetails: {
            ...this.state.updatedDetails,
            startDate: date,
            isGalleryUpdated: state.isGalleryUpdated === true ? true : false,
          },
        });
      }
    }
    if (id === "end") {
      state.endDate = date;
      this.setState(state);
      if (this.props.formType == "update") {
        this.setState({
          updatedDetails: {
            ...this.state.updatedDetails,
            endDate: date,
            isGalleryUpdated: state.isGalleryUpdated === true ? true : false,
          },
        });
      }
    }
  };

  handleCountryChange = (e) => {
    let state = this.state;
    let countryName;
    if (e.target.value !== "") {
      state.country = e.target.value;
      let parsedValue = this.props.tourCountriesJson.filter((item) => {
        if (item.country === e.target.value) {
          return item;
        }
      });
      countryName = this.props.tourCountriesJson.filter((item) => {
        if (item.country === e.target.value) {
          return item.locality.country;
        }
      })[0].country;
      state.countryCode = parsedValue[0].locality.country;
      state.locality = parsedValue[0].locality;
    } else {
      state.country = "";
      state.countryCode = "";
      state.locality = "";
    }
    if (this.props.formType == "update") {
      state.updatedDetails = {
        ...state.updatedDetails,
        ["country"]: countryName,
        isGalleryUpdated: state.isGalleryUpdated === true ? true : false,
      };
    }
    this.setState({ ...state });
  };

  // handleDescriptionChange = (e, editor) => {
  //   const data = editor.getData();
  //   this.setState({ description: data });

  //   this.setState({ description: data });

  //   if (this.props.formType == "update") {
  //     var body = data.replace("<p>", "");
  //     var rowdata = body.replace("</p>", "");
  //     this.setState({
  //       updatedDetails: {
  //         ...this.state.updatedDetails,
  //         description: rowdata,
  //         isGalleryUpdated: this.state.isGalleryUpdated === true ? true : false,
  //       },
  //     });
  //   }
  // };

  // handleDescriptionSetData = (editor) => {
  //   editor.setData(this.state.description);
  // };

  handleGoBack = () => {
    this.props.handleToggleModel();
  };

  uploadUrl = (data) => {
    this.props.actions.uploadUrl(data, this.onImageChangeHandler, "tours");
  };

  uploadPartnerThumbnail = (data) => {
    this.props.actions.uploadUrl(data, this.onPartnerChangeHandler, "tours");
  };

  componentDidUpdate = async (prevProps, prevState) => {
    if (
      (this.state.endPointSourceLongitude !==
        prevState.endPointSourceLongitude ||
        this.state.startPointSourceLongitude !==
          prevState.startPointSourceLongitude) &&
      !this.props.toursDetails
    ) {
      let state = { ...this.state };
      this.handleGetDistance(
        state.startPointSourceLatitude,
        state.startPointSourceLongitude,
        state.endPointSourceLatitude,
        state.endPointSourceLongitude
      );
    }
  };

  handleGetDistance = async (p1Lat, p1Long, p2Lat, p2Long) => {
    let state = { ...this.state };
    let directionsService = new window.google.maps.DirectionsService();
    let directionsRenderer = new window.google.maps.DirectionsRenderer();
    const route = {
      origin: new window.google.maps.LatLng(p1Lat, p1Long),
      destination: new window.google.maps.LatLng(p2Lat, p2Long),
      travelMode: "DRIVING",
    };

    return await directionsService
      .route(route, function(response, status) {
        // if (status !== "OK") {
        //   window.alert("Directions request failed due to " + status);
        // } else {
        directionsRenderer.setDirections(response); // Add route to the map
        // var directionsData = response.routes[0].legs[0]; // Get data about the mapped route
        // if (!directionsData) {
        //   window.alert("Directions request failed");
        // }
        // }
      })
      .then((distance) => {
        if (distance.status === "OK") {
          // setIsLoading(false);
          console.log("distance", distance);
          state.distanceCovered = Math.round(
            distance &&
              distance.routes &&
              distance.routes[0] &&
              distance.routes[0].legs &&
              distance.routes[0].legs[0] &&
              distance.routes[0].legs[0].distance &&
              distance.routes[0].legs[0].distance.value &&
              distance.routes[0].legs[0].distance.value / 1000
          ).toString();
          this.setState(state);
        }
      });
  };

  ValidateImg = (file, widths, heights, callBack) => {
    let img = new Image();
    img.src = window.URL.createObjectURL(file);
    img.onload = function() {
      if (img.width === widths && img.height === heights) {
        callBack(file);
      } else {
        callBack(file, widths, heights, "errors");
      }
    };
    console.log("widths", widths);
  };

  validateGalleryImage = (file, fileslength, index) => {
    let img = new Image();
    let newState = { ...this.state };
    img.src = window.URL.createObjectURL(file);
    let length = index + 1;
    let fileSize = file.size;
    if (fileSize <= 1000000) {
      newState.files.push(file);
    } else {
      if (fileslength === 1) {
        toast.error(
          // _.get(
          //   this.props.elements,
          //   "euToursElement.partnerPersonalFormElement.galleryImageSizeValidationElement",
          "The size of the image should be less than 1 mb"
        );
        // );
      } else {
        newState.errorsImage.push(file);
      }
    }
    if (fileslength === length) {
      this.callBackOnGalleryUpload();
    }
    this.setState(newState);
  };

  callBackOnGalleryUpload = (length, fileLength) => {
    let newState = { ...this.state };
    if (newState.errorsImage.length >= 1) {
      toast.error(
        // _.get(
        //   this.props.elements,
        //   // "euToursElement.partnerPersonalFormElement.galleryImageSizeValidationElementllll",
        //   "Some of the Image size is more than 1 mb which cannot be uploaded"
        // )
        "Some of the Image size is more than 1 mb which cannot be uploaded"
      );
    }
    for (
      let i = newState.imagePlaceHolder.length;
      i < newState.files.length;
      i++
    ) {
      this.props.actions.uploadUrl(
        newState.files[i],
        this.onGalleryImageChangeHandler
      );
    }
  };

  callBackOnUpload = (file, width, height, error) => {
    if (!error) {
      let newState = { ...this.state };
      let errorMessage = "";
      errorMessage = validation(
        newState.imageUpload,
        file.size,
        this.props.elements
      );
      if (errorMessage) {
        toast.error(errorMessage);
        newState.errors[newState.eventName] = errorMessage;
      } else {
        delete newState.errors[newState.eventName];
        errorMessage = "";
        newState[`${newState.eventName}Placeholder`] = file.name.split(" ")[0];
        if (newState.eventName === "thumbnailImage") {
          this.uploadUrl(file);
        } else if (newState.eventName === "thumbnailPartnerImage") {
          this.uploadPartnerThumbnail(file);
        }
      }
      this.setState(newState);
    }
    if (error) {
      toast.error(
        `${_.get(
          this.props.elements,
          "euToursElement.partnerPersonalFormElement.galleryImageDimensionValidationElement",
          `Image dimensions must be equal to`
        )} ${width} x ${height}`
      );
    }
  };

  onImageUpload = (e) => {
    if (
      this.state.thumbnailImage !== "" ||
      Array.from(e.target.files).length > 1
    ) {
      let newState = { ...this.state };
      toast.error(
        _.get(
          this.props.elements,
          "euToursElement.addNewTourElement.imagesLengthElement",
          "Only 1 image is allowed to upload"
        )
      );
      this.setState(newState);
    } else {
      let newState = { ...this.state };
      let errorMessage = "";
      this.ValidateImg(
        e.target.files[0],
        _.get(
          this.props.elements,
          "euToursElement.tourDimensionalElement.tourLandingThumbnailPageWidthElement",
          160
        ),
        _.get(
          this.props.elements,
          "euToursElement.tourDimensionalElement.tourLandingThumbnailPageHeightElement",
          190
        ),
        this.callBackOnUpload
      );

      newState.eventName = e.target.name;
      this.setState(newState);
    }
    e.target.value = "";
  };

  onPartnerthumbnailUpload = (e) => {
    if (
      this.state.thumbnailPartnerImage !== "" ||
      Array.from(e.target.files).length > 1
    ) {
      let newState = { ...this.state };
      toast.error(
        _.get(
          this.props.elements,
          "euToursElement.addNewTourElement.imagesLengthElement",
          "Only 1 image is allowed to upload"
        )
      );
      this.setState(newState);
    } else {
      let newState = { ...this.state };
      let errorMessage = "";
      this.ValidateImg(
        e.target.files[0],
        _.get(
          this.props.elements,
          "euToursElement.tourDimensionalElement.partnerDetailTourListingThumbnailWidthElement",
          360
        ),
        _.get(
          this.props.elements,
          "euToursElement.tourDimensionalElement.partnerDetailTourListingThumbnailHeightElement",
          310
        ),
        this.callBackOnUpload
      );

      newState.eventName = e.target.name;
      this.setState(newState);
    }
    e.target.value = "";
  };

  onImageChangeHandler = (data) => {
    let state = { ...this.state };
    state.thumbnailImage = data;
    toast.error(
      // _.get(
      //   elements,
      //   "euToursElement.partnerPersonalFormElement.regionRatingValidationElement",
      //   "Please select Partner Rating"
      "Images Uploaded Successfully"
    );
    if (this.props.formType == "update") {
      state.updatedDetails = {
        ...state.updatedDetails,
        thumbnailImage: data,
        thumbnailPartnerImage: state.thumbnailPartnerImage,
        gallery: state.images,
        isGalleryUpdated: true,
      };
      state.isGalleryUpdated = true;
    }
    this.setState(state);
  };

  onPartnerChangeHandler = (data) => {
    let state = { ...this.state };
    state.thumbnailPartnerImage = data;
    toast.error(
      // _.get(
      //   elements,
      //   "euToursElement.partnerPersonalFormElement.regionRatingValidationElement",
      //   "Please select Partner Rating"
      "Images Uploaded Successfully"
    );
    if (this.props.formType == "update") {
      state.updatedDetails = {
        ...state.updatedDetails,
        thumbnailImage: state.thumbnailImage,
        thumbnailPartnerImage: data,
        gallery: state.images,
        isGalleryUpdated: true,
      };
      state.isGalleryUpdated = true;
    }
    this.setState(state);
  };

  onGalleryUpload = (e) => {
    let newState = { ...this.state };
    newState.errorsImage = [];
    if (
      Array.from(e.target.files).length + this.state.images.length > 20 ||
      Array.from(e.target.files).length > 20
    ) {
      let newState = { ...this.state };
      toast.error(
        _.get(
          this.props.elements,
          "euToursElement.addNewTourElement.imageUploadValidation",
          "Max 20 images are allowed to be upload"
        )
      );

      this.setState(newState);
    } else {
      for (let i = 0; i < e.target.files.length; i++) {
        this.validateGalleryImage(e.target.files[i], e.target.files.length, i);
      }
    }
    e.target.value = "";
    this.setState(newState);
  };

  onGalleryImageChangeHandler = (data) => {
    let state = { ...this.state };
    state.images.push(data);
    state.imagePlaceHolder.push(data);
    if (state.files.length === state.images.length) {
      toast.error(
        // _.get(
        //   elements,
        //   "euToursElement.partnerPersonalFormElement.regionRatingValidationElement",
        //   "Please select Partner Rating"
        "Images Uploaded Successfully"
      );
    }
    if (this.props.formType == "update") {
      state.updatedDetails = {
        ...state.updatedDetails,
        thumbnailImage: state.thumbnailImage,
        thumbnailPartnerImage: state.thumbnailPartnerImage,
        gallery: state.images,
        isGalleryUpdated: true,
      };
      state.isGalleryUpdated = true;
    }
    this.setState(state);
  };

  handleModal = () => {
    let state = { ...this.state };
    state.togglePreviewModal = !state.togglePreviewModal;
    this.setState(state);
  };

  handleSubmitForm = () => {
    if (!this.props.toursDetails) {
      let { elements } = this.props;
      let state = { ...this.state };
      let data = {
        name: state.name ? state.name.trim() : "",
        source: state.startPoint,
        sourceLatitude: state.startPointSourceLatitude,
        sourceLongitude: state.startPointSourceLongitude,
        destination: state.endPoint,
        destinationLatitude: state.endPointSourceLatitude,
        destinationLongitude: state.endPointSourceLongitude,
        startDate: moment(state.startDate).format("YYYY-MM-DD"),
        endDate: moment(state.endDate).format("YYYY-MM-DD"),
        description: state.description,
        country: state.country,
        locality: state.locality,
        category: state.category,
        region: state.region,
        totalDistance: state.distanceCovered,
        thumbnailImage: state.thumbnailImage,
        gallery: state.images,
        thumbnailPartnerImage: state.thumbnailPartnerImage,
        redirectionUrl: state.redirectionUrl,
      };
      console.log(data);
      if (state.name === "")
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.enterExpNameValidation",
            "Please enter tour name"
          )
        );

      if (state.startPoint === "")
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.enterExpStartLocationValidation",
            "Please enter tour start location"
          )
        );

      if (state.endPoint === "")
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.enterExpEndLocationValidation",
            "Please enter tour End location"
          )
        );

      if (state.startDate === "" || state.startDate === null)
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.enterExpStartDateValidation",
            "Please select tour start date"
          )
        );

      if (state.endDate === "" || state.endDate === null)
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.enterExpEndDateValidation",
            "Please select tour End date"
          )
        );
      if (state.redirectionUrl === "")
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.enterRedirectionUrlValidation",
            "Please enter redirection url"
          )
        );
      if (state.region === "" || state.region === null)
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.selectRegionValidation",
            "Please select region"
          )
        );

      if (state.country === "")
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.selectCountryValidation",
            "Please select country"
          )
        );

      if (state.description === "")
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.enterDescriptionValidation",
            "Please enter short description for the tour"
          )
        );

      if (state.thumbnailImage === "")
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.uploadThumbnailImageValidation",
            "Please upload the thumbnail for tour landing filter"
          )
        );
      if (state.thumbnailPartnerImage === "")
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.thumbnailPartnerImageValidation",
            "Please upload the thumbnail for tour listing on partner detail page"
          )
        );
      if (state.images.length === 0)
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.uploadgalleryImageOfExpValidation",
            "Please upload gallery images of the tour"
          )
        );
      if (this.state.errors && Object.keys(this.state.errors).length === 0) {
        return this.handleCreateTour(data);
      }
      console.log("data", data);
    } else if (this.props.formType == "update") {
      let state = { ...this.state };
      let data = {
        ...state.updatedDetails,
        category: "TOUR",
        wanderlustId: this.props.toursDetails._id,
      };
      if (state.name === "")
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.enterExpNameValidation",
            "Please enter tour name"
          )
        );

      if (state.startPoint === "")
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.enterExpStartLocationValidation",
            "Please enter tour start location"
          )
        );

      if (state.endPoint === "")
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.enterExpEndLocationValidation",
            "Please enter tour End location"
          )
        );

      if (state.startDate === "" || state.startDate === null)
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.enterExpStartDateValidation",
            "Please select tour start date"
          )
        );

      if (state.endDate === "" || state.endDate === null)
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.enterExpEndDateValidation",
            "Please select tour End date"
          )
        );
      if (state.redirectionUrl === "")
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.enterRedirectionUrlValidation",
            "Please enter redirection url"
          )
        );
      if (state.region === "" || state.region === null)
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.selectRegionValidation",
            "Please select region"
          )
        );

      if (state.country === "")
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.selectCountryValidation",
            "Please select country"
          )
        );

      if (state.description === "")
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.enterDescriptionValidation",
            "Please enter short description for the tour"
          )
        );

      if (state.thumbnailImage === "")
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.uploadThumbnailImageValidation",
            "Please upload the thumbnail for tour listing filter"
          )
        );
      if (state.thumbnailPartnerImage === "")
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.thumbnailPartnerImageValidation",
            "Please upload the thumbnail for tour listing on partner detail page"
          )
        );
      if (state.images.length === 0)
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.uploadgalleryImageOfExpValidation",
            "Please upload gallery images of the tour"
          )
        );
      if (this.state.errors && Object.keys(this.state.errors).length === 0) {
        return this.props.actions.updateToursDetails(
          data,
          this.props.toursDetails._id,
          this.handleUpdateTourCallBack
        );
      }
    } else {
      let state = { ...this.state };
      let { elements } = this.props;
      // var body = state.description.replace("<p>", "");
      // var rowdata = body.replace("</p>", "");
      let data = {
        name: state.name ? state.name.trim() : "",
        source: state.startPoint,
        sourceLatitude: state.startPointSourceLatitude,
        sourceLongitude: state.startPointSourceLongitude,
        destination: state.endPoint,
        destinationLatitude: state.endPointSourceLatitude,
        destinationLongitude: state.endPointSourceLongitude,
        startDate: moment(state.startDate).format("YYYY-MM-DD"),
        endDate: moment(state.endDate).format("YYYY-MM-DD"),
        description: state.description,
        country: state.country,
        locality: state.locality,
        category: state.category,
        region: state.region,
        totalDistance: state.distanceCovered,
        thumbnailImage: state.thumbnailImage,
        gallery: state.images,
        thumbnailPartnerImage: state.thumbnailPartnerImage,
        redirectionUrl: state.redirectionUrl,
        wanderlustId: this.props.toursDetails && this.props.toursDetails._id,
      };
      if (state.name === "")
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.enterExpNameValidation",
            "Please enter tour name"
          )
        );

      if (state.startPoint === "")
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.enterExpStartLocationValidation",
            "Please enter tour start location"
          )
        );

      if (state.endPoint === "")
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.enterExpEndLocationValidation",
            "Please enter tour End location"
          )
        );

      if (state.startDate === "" || state.startDate === null)
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.enterExpStartDateValidation",
            "Please select tour start date"
          )
        );

      if (state.endDate === "" || state.endDate === null)
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.enterExpEndDateValidation",
            "Please select tour End date"
          )
        );
      if (state.redirectionUrl === "")
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.enterRedirectionUrlValidation",
            "Please enter redirection url"
          )
        );
      if (state.region === "" || state.region === null)
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.selectRegionValidation",
            "Please select region"
          )
        );

      if (state.country === "")
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.selectCountryValidation",
            "Please select country"
          )
        );

      if (state.description === "")
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.enterDescriptionValidation",
            "Please enter short description for the tour"
          )
        );

      if (state.thumbnailImage === "")
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.uploadThumbnailImageValidation",
            "Please upload the thumbnail for tour listing filter"
          )
        );
      if (state.thumbnailPartnerImage === "")
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.thumbnailPartnerImageValidation",
            "Please upload the thumbnail for tour listing on partner detail page"
          )
        );
      if (state.images.length === 0)
        return toast.error(
          _.get(
            this.props.elements,
            "euToursElement.addNewTourElement.uploadgalleryImageOfExpValidation",
            "Please upload gallery images of the tour"
          )
        );
      if (this.state.errors && Object.keys(this.state.errors).length === 0) {
        return this.handleUpdateTourInfo(data);
      }
    }
  };

  handleDeleteImage = (index) => {
    let state = { ...this.state };
    state.imagePlaceHolder.splice(index, 1);
    state.images.splice(index, 1);
    state.files.splice(index, 1);
    state.updatedDetails = {
      ...state.updatedDetails,
      thumbnailImage: state.thumbnailImage,
      thumbnailPartnerImage: state.thumbnailPartnerImage,
      gallery: state.images,
      isGalleryUpdated: true,
    };
    state.isGalleryUpdated = true;
    this.setState(state);
  };

  handleDeleteThumbnailImage = (index) => {
    let state = { ...this.state };
    state.thumbnailImagePlaceholder = "";
    state.thumbnailImage = "";
    state.updatedDetails = {
      ...state.updatedDetails,
      thumbnailImage: state.thumbnailImage,
      thumbnailPartnerImage: state.thumbnailPartnerImage,
      gallery: state.images,
      isGalleryUpdated: true,
    };
    state.isGalleryUpdated = true;
    this.setState(state);
  };

  handleDeleteThumbnailPartnerImage = (index) => {
    let state = { ...this.state };
    state.thumbnailPartnerImage = "";
    state.thumbnailPartnerImagePlaceholder = "";
    state.updatedDetails = {
      ...state.updatedDetails,
      thumbnailImage: state.thumbnailImage,
      thumbnailPartnerImage: state.thumbnailPartnerImage,
      gallery: state.images,
      isGalleryUpdated: true,
    };
    state.isGalleryUpdated = true;
    this.setState(state);
  };

  componentDidMount() {
    let state = { ...this.state };

    if (this.props.toursDetails) {
      state.name = this.props.toursDetails && this.props.toursDetails.name;
      state.startPoint =
        this.props.toursDetails &&
        this.props.toursDetails.startPoint &&
        this.props.toursDetails.startPoint.name;
      state.startPointSourceLatitude =
        this.props.toursDetails &&
        this.props.toursDetails.startPoint &&
        this.props.toursDetails.startPoint.latitude;
      state.startPointSourceLongitude =
        this.props.toursDetails &&
        this.props.toursDetails.startPoint &&
        this.props.toursDetails.startPoint.longitude;
      state.endPoint =
        this.props.toursDetails &&
        this.props.toursDetails.endPoint &&
        this.props.toursDetails.endPoint.name;
      state.endPointSourceLatitude =
        this.props.toursDetails &&
        this.props.toursDetails.endPoint &&
        this.props.toursDetails.endPoint.latitude;
      state.endPointSourceLongitude =
        this.props.toursDetails &&
        this.props.toursDetails.endPoint &&
        this.props.toursDetails.endPoint.longitude;
      state.startDate =
        this.props.toursDetails &&
        new Date(this.props.toursDetails.startDateIso);
      state.endDate =
        this.props.toursDetails && new Date(this.props.toursDetails.endDateIso);
      state.distanceCovered =
        this.props.toursDetails && this.props.toursDetails.totalDistance;
      state.country =
        this.props.toursDetails && this.props.toursDetails.country;
      state.description =
        this.props.toursDetails && this.props.toursDetails.description;
      state.region = this.props.toursDetails && this.props.toursDetails.region;
      state.locality =
        this.props.toursDetails && this.props.toursDetails.locality;
      state.redirectionUrl =
        this.props.toursDetails && this.props.toursDetails.redirectionUrl;
      state.thumbnailImage =
        this.props.toursDetails && this.props.toursDetails.thumbnailImage;
      state.thumbnailImagePlaceholder =
        this.props.toursDetails &&
        this.props.toursDetails.thumbnailImage &&
        this.props.toursDetails.thumbnailImage.split("/")[4];
      for (let i = 0; i < this.props.toursDetails.gallery.length; i++) {
        state.images.push(
          this.props.toursDetails && this.props.toursDetails.gallery[i]
        );
        state.imagePlaceHolder.push(
          this.props.toursDetails &&
            this.props.toursDetails.gallery &&
            this.props.toursDetails.gallery[i]
        );
        state.files.push(
          this.props.toursDetails && this.props.toursDetails.gallery[i]
        );
      }
      state.thumbnailPartnerImage =
        this.props.toursDetails &&
        this.props.toursDetails.thumbnailPartnerImage;
      state.thumbnailPartnerImagePlaceholder =
        this.props.toursDetails &&
        this.props.toursDetails.thumbnailPartnerImage &&
        this.props.toursDetails.thumbnailPartnerImage.split("/")[4];
      state.partnerName =
        this.props.toursDetails &&
        this.props.toursDetails.partnerId &&
        this.props.toursDetails.partnerId.name;
      state.partnerEmailId =
        this.props.toursDetails &&
        this.props.toursDetails.partnerId &&
        this.props.toursDetails.partnerId.email;
    }
    this.setState(state);
    this.handleFetchTourCountriesJson();
  }

  handleFetchTourCountriesJson = () => {
    this.props.global.fetchingCountriesJson();
  };

  componentDidUpdate() {
    if (
      this.state.images.length === this.state.files.length &&
      this.state.images.length >= 1
    ) {
      let state = { ...this.state };
      toast.error(
        // _.get(
        //   elements,
        //   "euToursElement.partnerPersonalFormElement.regionRatingValidationElement",
        //   "Please select Partner Rating"
        "Images Uploaded Successfully"
      );
      state.files = [];
      this.setState(state);
    }
    if (
      this.state.thumbnailImage !== "" ||
      this.state.video !== "" ||
      this.state.thumbnailDetailBannerMobile !== "" ||
      this.state.thumbnailDetailBannerDesktop !== "" ||
      this.state.thumbnailListingDesktop !== "" ||
      this.state.thumbnailVideo !== "" ||
      this.state.thumbnailDetailMobile !== "" ||
      this.state.thumbnailDetailDesktop !== "" ||
      this.state.thumbnailListingMobile !== ""
    ) {
      toast.error(
        // _.get(
        //   elements,
        //   "euToursElement.partnerPersonalFormElement.regionRatingValidationElement",
        //   "Please select Partner Rating"
        "Images Uploaded Successfully"
      );
    }
  }

  render() {
    let { elements } = this.props;
    console.log("state", this.state);
    console.log("sss", this.props.toursDetails);
    const renderFunc = ({
      getInputProps,
      suggestions,
      getSuggestionItemProps,
      loading,
    }) => (
      <div>
        <Input
          className="input-text"
          {...getInputProps({
            placeholder: _.get(
              elements,
              "euToursElement.addNewTourElement.searchPlacesElement",
              "Search Places ..."
            ),
          })}
        />
        <div className="autocomplete-dropdown-container">
          {loading && <div>Loading...</div>}
          {suggestions.map((suggestion) => {
            const className = suggestion.active
              ? "suggestion-item"
              : "suggestion-item";
            const style = suggestion.active
              ? { backgroundColor: "#fafafa", cursor: "pointer" }
              : { backgroundColor: "#ffffff", cursor: "pointer" };
            return (
              <div
                {...getSuggestionItemProps(suggestion, {
                  className,
                  style,
                })}
              >
                <span>{suggestion.description}</span>
              </div>
            );
          })}
        </div>
      </div>
    );
    return (
      <div className="hideSearch mt-4">
        {this.state.errors &&
          Object.keys(this.state.errors).length === 0 &&
          this.state.images &&
          this.state.files &&
          this.state.images.length !== this.state.files.length && <Loader />}
        {this.state.errors &&
          Object.keys(this.state.errors).length === 0 &&
          this.state.thumbnailImage === "" &&
          this.state.thumbnailImagePlaceholder && <Loader />}
        {this.state.errors &&
          Object.keys(this.state.errors).length === 0 &&
          this.state.thumbnailPartnerImage === "" &&
          this.state.thumbnailPartnerImagePlaceholder && <Loader />}
        <Form>
          <Row>
            <Col sm={12}>
              <CartTitle
                title={_.get(
                  elements,
                  "euToursElement.addNewTourElement.addNewTourHeadingElement",
                  "Add New Tour"
                )}
                Name={"Filter"}
                customClass={"hidebtn"}
                innerTextClass={"hidetext"}
                iconClass={"hideexcel"}
              />
            </Col>

            <Col sm={12}>
              <Card className="mb-3">
                <CardBody>
                  <Row>
                    <Col md="12">
                      <h2 className="title-bar secondary-title font-weight-bold my-3 pb-2 themeColor">
                        <span>
                          {" "}
                          {_.get(
                            elements,
                            "euToursElement.addNewTourElement.addNewTourSubHeadingElement",
                            "Tour Details"
                          )}
                        </span>
                      </h2>
                    </Col>
                    <Col className="each_input" lg={4}>
                      <InputText
                        labelName={_.get(
                          elements,
                          "euToursElement.addNewTourElement. addNewTourNameElement",
                          "Name"
                        )}
                        mandatory
                        inputType={"text"}
                        inputName={"name"}
                        InputClass={"inputText mb-0"}
                        inputPlaceholder={_.get(
                          elements,
                          "euToursElement.addNewTourElement.addNewTourNamePlaceholderElement",
                          "Name"
                        )}
                        customValue={this.state.name}
                        customMaxLength={75}
                        customMinLength={2}
                        customOnChange={(e) => this.handleChange(e)}
                      />
                      {this.state &&
                        this.state.errors &&
                        this.state.errors.name && (
                          <div className="error_msg">
                            {/* <Icon className="mr-2" size={20} icon={ic_info_outline} /> */}
                            {this.state &&
                              this.state.errors &&
                              this.state.errors.name}
                          </div>
                        )}
                    </Col>
                    <Col className="each_input" lg={4}>
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.addNewTourElement.startLocationElement",
                          "Start Location"
                        )}
                        <span className="mandate_mark">*</span>
                      </Label>
                      <FormGroup className="position-relative">
                        <PlacesAutocomplete
                          name={"startPoint"}
                          value={this.state.startPoint}
                          onChange={(startPoint) =>
                            this.handleChangeStartingLocation(startPoint)
                          }
                          onSelect={(startPoint) =>
                            this.handleSelectGeoAddressForStartPoint(startPoint)
                          }
                        >
                          {renderFunc}
                        </PlacesAutocomplete>
                      </FormGroup>
                    </Col>
                    <Col className="each_input" lg={4}>
                      <InputText
                        labelName={_.get(
                          elements,
                          "euToursElement.addNewTourElement.startLocationLatitudeElement",
                          "Start Location Latitude"
                        )}
                        inputType={"text"}
                        inputName={"firstName"}
                        InputClass={"inputText mb-0"}
                        disabledType={true}
                        customValue={this.state.startPointSourceLatitude}
                        inputPlaceholder={_.get(
                          elements,
                          "euToursElement.addNewTourElement.startLocationLatitudePlaceholderElement",
                          "Start Location Latitude"
                        )}
                      />
                    </Col>
                    <Col className="each_input" lg={4}>
                      <InputText
                        labelName={_.get(
                          elements,
                          "euToursElement.addNewTourElement.startLocationLongitudeElement",
                          "Start Location Longitude"
                        )}
                        inputType={"text"}
                        inputName={"firstName"}
                        InputClass={"inputText mb-0"}
                        disabledType={true}
                        customValue={this.state.startPointSourceLongitude}
                        inputPlaceholder={_.get(
                          elements,
                          "euToursElement.addNewTourElement.startLocationLongitudePlaceholderElement",
                          "Start Location Longitude"
                        )}
                      />
                    </Col>
                    <Col className="each_input" lg={4}>
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.addNewTourElement.endLocationElement",
                          "end Location"
                        )}
                        <span className="mandate_mark">*</span>
                      </Label>
                      <FormGroup className="position-relative">
                        <PlacesAutocomplete
                          name={"endPoint"}
                          value={this.state.endPoint}
                          onChange={(endPoint) =>
                            this.handleChangeEndingLocation(endPoint)
                          }
                          onSelect={(endPoint) =>
                            this.handleSelectGeoAddressForEndPoint(endPoint)
                          }
                        >
                          {renderFunc}
                        </PlacesAutocomplete>
                      </FormGroup>
                    </Col>
                    <Col className="each_input" lg={4}>
                      <InputText
                        labelName={_.get(
                          elements,
                          "euToursElement.addNewTourElement.endLocationLatitudeElement",
                          "end Location Latitude"
                        )}
                        inputType={"text"}
                        inputName={"firstName"}
                        InputClass={"inputText mb-0"}
                        disabledType={true}
                        customValue={this.state.endPointSourceLatitude}
                        inputPlaceholder={_.get(
                          elements,
                          "euToursElement.addNewTourElement.endLocationLatitudePlaceholderElement",
                          "end Location Latitude"
                        )}
                      />
                    </Col>
                    <Col className="each_input" lg={4}>
                      <InputText
                        labelName={_.get(
                          elements,
                          "euToursElement.addNewTourElement.endLocationLongitudeElement",
                          "end Location Longitude"
                        )}
                        inputType={"text"}
                        inputName={"firstName"}
                        InputClass={"inputText mb-0"}
                        disabledType={true}
                        customValue={this.state.endPointSourceLongitude}
                        inputPlaceholder={_.get(
                          elements,
                          "euToursElement.addNewTourElement.endLocationLongitudePlaceholderElement",
                          "end Location Longitude"
                        )}
                      />
                    </Col>
                    <Col className="each_input" lg={4}>
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.addNewTourElement.startDateElement",
                          "Start Date"
                        )}{" "}
                        <span className="mandate_mark">*</span>
                      </Label>
                      <FormGroup>
                        <CustomDatepicker
                          value={this.state.startDate}
                          name={"startDate"}
                          customPlaceHolder={_.get(
                            elements,
                            "euToursElement.addNewTourElement.startDatePlaceholderElement",
                            "Start Date"
                          )}
                          handleDateChange={(e) =>
                            this.handleTourDates(e, "start")
                          }
                          customShowMonthDropdown={true}
                          customShowYearDropdown={true}
                          customMinDate={new Date()}
                        />
                      </FormGroup>
                    </Col>
                    <Col className="each_input" lg={4}>
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.addNewTourElement.endDateElement",
                          "End Date"
                        )}{" "}
                        <span className="mandate_mark">*</span>
                      </Label>
                      <FormGroup>
                        <CustomDatepicker
                          value={this.state.endDate}
                          name={"endDate"}
                          customPlaceHolder={_.get(
                            elements,
                            "euToursElement.addNewTourElement.endDatePlaceholderElement",
                            "End Date"
                          )}
                          handleDateChange={(e) =>
                            this.handleTourDates(e, "end")
                          }
                          customShowMonthDropdown={true}
                          customShowYearDropdown={true}
                          customMinDate={this.state.startDate}
                        />
                      </FormGroup>
                    </Col>
                    <Col className="each_input" lg={4}>
                      <InputText
                        labelName={_.get(
                          elements,
                          "euToursElement.addNewTourElement.distanceCoveredLabelElement",
                          "Estimated Distance Covered (KM)"
                        )}
                        inputType={"text"}
                        inputName={"distanceCovered"}
                        InputClass={"inputText mb-0"}
                        // disabledType={true}
                        inputPlaceholder={_.get(
                          elements,
                          "euToursElement.addNewTourElement.distanceCoveredPlaceholderElement",
                          "Estimated Distance Covered"
                        )}
                        customValue={this.state.distanceCovered}
                        customOnChange={(e) => this.handleChange(e)}
                      />
                    </Col>
                    <Col className="each_input" lg={4}>
                      <InputText
                        labelName={_.get(
                          elements,
                          "euToursElement.addNewTourElement.redirectionalUrlLabelElement",
                          "Redirection-Url"
                        )}
                        mandatory
                        inputType={"text"}
                        inputName={"redirectionUrl"}
                        InputClass={"inputText mb-0"}
                        inputPlaceholder={_.get(
                          elements,
                          "euToursElement.addNewTourElement.redirectionUrlPlaceholderElement",
                          "https://www.example.com"
                        )}
                        customValue={this.state.redirectionUrl}
                        customOnChange={this.handleChange}
                      />
                    </Col>
                    <Col className="each_input" lg={4}>
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.addNewTourElement.regionLabelElement",
                          "Region"
                        )}
                        <span className="mandate_mark">*</span>
                      </Label>
                      <FormGroup className=" confirmRiderSelect select_options">
                        <Input
                          type="select"
                          name="region"
                          className="w-100 customeSelectBtn"
                          value={this.state.region}
                          onChange={(e) => this.handleChange(e)}
                        >
                          <option value="">
                            {_.get(
                              elements,
                              "euToursElement.addNewTourElement.regionPlaceholerElement",
                              "Select Region"
                            )}
                          </option>
                          <option value="EUROPE">Europe</option>
                          <option value="ASIA PACIFIC">ASIA PACIFIC</option>
                          <option value="AMERICAS">AMERICAS</option>

                          <option value="MIDDLE EAST & AFRICA">
                            MIDDLE EAST & AFRICA
                          </option>
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col xl={4} lg={4} md={6} sm={6}>
                      <label class="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.addNewTourElement.countryLabelElemnt",
                          "Country"
                        )}
                        <span className="mandate_mark">*</span>
                      </label>
                      <FormGroup className=" confirmRiderSelect select_options">
                        <Input
                          type="select"
                          name="City"
                          className="w-100 customeSelectBtn"
                          onChange={this.handleCountryChange}
                          value={this.state.country}
                        >
                          <option value="">
                            {_.get(
                              elements,
                              "euToursElement.addNewTourElement.countryPlaceholderElement",
                              "Select Country"
                            )}
                          </option>
                          {this.props.tourCountriesJson &&
                            this.props.tourCountriesJson.length > 0 &&
                            this.props.tourCountriesJson
                              .sort((a, b) =>
                                a.name > b.name ? 1 : b.name > a.name ? -1 : 0
                              )
                              .map((item, index) => (
                                <option key={index} value={item.country}>
                                  {item.country}
                                </option>
                              ))}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col className="each_input" xl={12}>
                      <Label className="inputLabel" for="--">
                        {_.get(
                          elements,
                          "euToursElement.addNewTourElement.descriptionLabelElement",
                          "Description"
                        )}
                        <span className="mandate_mark">*</span>
                      </Label>
                      <FormGroup>
                        {/* <CKEditor
                          editor={ClassicEditor}
                          onInit={(editor) =>
                            this.handleDescriptionSetData(editor)
                          }
                          data={this.state.description}
                          onChange={(e, editor) =>
                            this.handleDescriptionChange(e, editor)
                          }
                        /> */}
                        <InputText
                        // labelName= {_.get(
                        //   elements,
                        //   "euToursElement.addNewTourElement.descriptionLabelElement",
                        //   "Description"
                        // )}
                        inputType={"textarea"}
                        inputName={"description"}
                        InputClass={"inputText mb-0"}
                        inputPlaceholder= {_.get(
                          elements,
                          "euToursElement.addNewTourElement.descriptionLabelElement",
                          "Description"
                        )}
                        customOnChange={this.handleChange}
                        customValue={this.state.description}
                      />
                      </FormGroup>
                    </Col>
                    <Col className="top_line" md="12">
                      <h2 className="title-bar secondary-title font-weight-bold mt-5 my-3 pb-2 themeColor">
                        <span>
                          {_.get(
                            elements,
                            "euToursElement.addNewTourElement.UploadMediaSubHeadingElement",
                            "Upload Media"
                          )}
                        </span>
                      </h2>
                    </Col>
                    <Col xl={6}>
                      <label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.addNewTourElement.thumbnailImageLabelElement",
                          "Tour Landing Page - Thumbnail - Common (160 x 190 px)"
                        )}
                        <span className="mandate_mark">*</span>
                      </label>
                      <div className="d-flex form-control file-inputMain overflow-text">
                        <input
                          name="thumbnailImage"
                          type="file"
                          accept=".jpg, .jpeg, .png, .webp"
                          placeholder={_.get(
                            elements,
                            "euToursElement.addNewTourElement.thumbnailImagePlaceholderElement",
                            "Tour Landing Page - Thumbnail - Common (160 x 190 px)"
                          )}
                          className="inputText mb-0"
                          onChange={(e) => this.onImageUpload(e)}
                        />
                        <Icon
                          className="text-dark uploadIcon"
                          size={18}
                          icon={ic_file_upload}
                        />
                        {this.state.thumbnailImagePlaceholder !== "" &&
                        this.state.thumbnailImagePlaceholder !== undefined ? (
                          <div className="file-name mr-2">
                            <div className="file-large-name">
                              {this.state.thumbnailImagePlaceholder}
                            </div>
                            <Icon
                              className="closeIcon"
                              size={18}
                              icon={close}
                              onClick={() => this.handleDeleteThumbnailImage()}
                            />
                          </div>
                        ) : (
                          <span>
                            {_.get(
                              elements,
                              "euToursElement.addNewTourElement.thumbnailImageLabelElement",
                              "Tour Landing Page - Thumbnail - Common (160 x 190 px)"
                            )}
                          </span>
                        )}
                      </div>
                      <div className="image_rules">
                        {_.get(
                          elements,
                          "euToursElement.addNewTourElement.thumnailImageFormatElement",
                          "Format: JPG PNG JPEG WEBP. Max Size: 1MB."
                        )}
                      </div>
                    </Col>
                    <Col xl={6}>
                      <label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.addNewTourElement.partnerImagesLabelElement",
                          "Partner Detail Page - Tour Listing Thumbnail - Common (360 x 310 px)"
                        )}

                        <span className="mandate_mark">*</span>
                      </label>
                      <div className="d-flex form-control file-inputMain overflow-text">
                        <input
                          name="thumbnailPartnerImage"
                          type="file"
                          accept=".jpg, .jpeg, .png, .webp"
                          placeholder={_.get(
                            elements,
                            "euToursElement.addNewTourElement.partnerImagesLabelElement",
                            "Partner Detail Page - Tour Listing Thumbnail - Common (360 x 310 px)"
                          )}
                          className="inputText mb-0"
                          onChange={(e) => this.onPartnerthumbnailUpload(e)}
                        />
                        <Icon
                          className="text-dark uploadIcon"
                          size={18}
                          icon={ic_file_upload}
                        />
                        {this.state.thumbnailPartnerImagePlaceholder !== "" &&
                        this.state.thumbnailPartnerImagePlaceholder !==
                          undefined ? (
                          <div className="file-name mr-2">
                            <div className="file-large-name">
                              {this.state.thumbnailPartnerImagePlaceholder}
                            </div>
                            <Icon
                              className="closeIcon"
                              size={18}
                              icon={close}
                              onClick={() =>
                                this.handleDeleteThumbnailPartnerImage()
                              }
                            />
                          </div>
                        ) : (
                          <span>
                            {_.get(
                              elements,
                              "euToursElement.addNewTourElement.partnerImagesLabelElement",
                              "Partner Detail Page - Tour Listing Thumbnail - Common (360 x 310 px)"
                            )}
                          </span>
                        )}
                      </div>
                      <div className="image_rules">
                        {_.get(
                          elements,
                          "euToursElement.addNewTourElement.thumnailImageFormatElement",
                          "Format: JPG PNG JPEG WEBP. Max Size: 1MB."
                        )}
                      </div>
                    </Col>
                    <Col xl={6}>
                      <label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.addNewTourElement.galleryImagesLabelElement",
                          "Gallery Images Common"
                        )}
                        <span className="mandate_mark">*</span>
                      </label>
                      <div className="d-flex form-control file-inputMain fileInputHeight overflow-text">
                        <input
                          type="file"
                          name="images"
                          accept=".jpg, .jpeg, .png, .webp"
                          onChange={(e) => this.onGalleryUpload(e)}
                          className="inputText form-control mb-0"
                          multiple
                        />
                        <Icon
                          className="text-dark uploadIcon"
                          size={18}
                          icon={ic_file_upload}
                        />
                        {this.state.imagePlaceHolder &&
                        this.state.imagePlaceHolder.length > 0 ? (
                          this.state.imagePlaceHolder.map((item, index) => (
                            <div className="file-name my-1 mr-2">
                              <div className="file-large-name">
                                {item.split("/")[4]}
                              </div>
                              <Icon
                                className="closeIcon"
                                size={18}
                                icon={close}
                                onClick={() => this.handleDeleteImage(index)}
                              />
                            </div>
                          ))
                        ) : (
                          <span>
                            {" "}
                            {_.get(
                              elements,
                              "euToursElement.addNewTourElement.galleryImagesLabelElement",
                              "Gallery Images Common"
                            )}
                          </span>
                        )}
                      </div>
                      <div className="image_rules">
                        {_.get(
                          elements,
                          "euToursElement.addNewTourElement.galleryImageFormatElement",
                          "Max 20 images allowed. Format: JPG JPEG WEBP PNG. Max Size: 1MB."
                        )}
                      </div>
                    </Col>
                    <Col className="top_line" md="12"></Col>
                  </Row>
                  <Row>
                    <Col
                      lg={12}
                      className="d-flex align-items-center justify-content-center"
                    >
                      <div className="d-flex mt-5">
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "euToursElement.addNewTourElement.backButtonElement",
                            "Back"
                          )}
                          customClick={this.handleGoBack}
                          customClass={
                            "btn-outline-dark ml-2 bg-none btnthemeColor"
                          }
                        />
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "euToursElement.addNewTourElement.previewButtonElement",
                            "Preview"
                          )}
                          customClass={
                            "btn-outline-dark ml-2 bg-none btnthemeColor"
                          }
                          customClick={this.handleModal}
                        />
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "euToursElement.addNewTourElement.submitButtonElement",
                            "Submit"
                          )}
                          customClick={this.handleSubmitForm}
                          customClass={
                            "btn-outline-dark ml-2 bg-none btnthemeColor"
                          }
                        />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Form>
        <Modal
          isOpen={this.state.togglePreviewModal}
          toggle={() => this.handleModal()}
          backdrop={true}
          centered={true}
          size="xl"
          className="modal_main"
        >
          <ModalBody>
            <TourPreviewPage
              handleToggleModel={() => this.handleModal()}
              tourDetailsData={this.state}
            />
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(sessionActions, dispatch),
    global: bindActionCreators(globalActions, dispatch),
  };
}

function mapStateToProps(state) {
  return {
    countryStatus: state.Events.countryStatus,
    tourCountriesJson: state.Global.tourCountriesJson,
    createTourStatus: state.Events.createTourStatus,
    userProfile: state.Auth.userProfile,
    elements: state.Elements.elements,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddNewTour)
);
